
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/automotive-software/scrap-yard-software",
      function () {
        return require("private-next-pages/automotive-software/scrap-yard-software.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/automotive-software/scrap-yard-software"])
      });
    }
  